// Надо сделать рисование на промисах, image хранить в замыкании в drawLogo

import React from 'react';

export default class Canvas extends React.Component {
  constructor(props) {
    super(props);
    this.image_props = ['logo', 'background', 'laurus'];
    this.image_props.map((propName) => {
      this.props[propName].image = new Image();
    })
  }
  componentWillReceiveProps(nextProps) {
    this.image_props.map((propName) => {
      nextProps[propName].image = this.props[propName].image;
    })
  }

  componentDidMount() {this.updateCanvas();}
  componentDidUpdate() {this.updateCanvas();}

  updateCanvas() {
    this.ctx = this.canvas.getContext('2d');
    Promise.all(this.image_props.map(this.loadSrc)).then(() => {
      this.clear();
      if (this.props.background.src) this.drawBackground();
      if (this.props.background.src && this.props.laurus.src) this.drawGradient();
      if (this.props.logo.src) this.drawLogo();
      if (this.props.laurus.src) this.drawLaurus();
      if (this.props.paragraph.text) this.drawParagraph();
    })
  }

  clear() {
    this.ctx.clearRect(0, 0, this.props.width, this.props.height);
  }

  drawBackground() {
    let image = this.props.background.image,
        backgroundWidth = image.width + this.props.background.dWidth,
        x = this.props.background.x,
        y = this.props.background.y,
        width = backgroundWidth,
        height = backgroundWidth * image.height / image.width;
    this.ctx.drawImage(image, x, y, width, height);
  }

  drawLogo() {
    var image = this.props.logo.image
    var width = 160;
    var height = 84;
    var x = (this.props.width - width) / 2; // center
    var y = '50';
    this.ctx.drawImage(image, x, y, width, height);
  }

  drawGradient() {
    var gradStartY = 350;
    var gradEndY = 600;
    var gradient = this.ctx.createLinearGradient(0, gradStartY, 0, gradEndY);
    gradient.addColorStop(0, 'rgba(0, 0, 0, 0)');
    gradient.addColorStop(1, 'rgba(0, 0, 0, .7)');
    this.ctx.fillStyle = gradient;
    this.ctx.fillRect(0, 0, this.props.width, this.props.height);
  }

  drawLaurus() {
    var image = this.props.laurus.image
    let y = this.props.height - image.height;
    this.ctx.drawImage(image, 0, y);

    // mirror laurus
    this.ctx.save()
    this.ctx.scale(-1, 1)
    this.ctx.drawImage(image, -this.props.width, y);
    this.ctx.restore();
  }

  drawParagraph() {
    let verCenter;

    switch (this.props.paragraph.position) {
      case 'bottom':
        let bottomOffset = 100;
        verCenter = this.props.height - bottomOffset;
        break;
      case 'center':
        let topOffset = this.props.logo.src ? 120 : 0;
        verCenter = (this.props.height - topOffset)/2 + topOffset;
        break;
      default:
        0;
    }

    var horCenter = this.props.width/2;
    this.ctx.font = '300 48px "Open Sans"';
    this.ctx.fillStyle = this.props.paragraph.color;
    this.ctx.textAlign = "center";
    var lineHeight = this.ctx.measureText("M").width * 1.4;
    var lines = this.props.paragraph.text.split("\n");

    var y = verCenter - ((lines.length - 1) * lineHeight / 2)
    for (var i = 0; i < lines.length; ++i) {
      this.ctx.fillText(lines[i], horCenter, y);
      y += lineHeight;
    }
  }


  loadSrc = (propName) => {
    if (!this.props[propName].src) return Promise.resolve();

    return new Promise((resolve) => {
      let image = this.props[propName].image;
      let src = this.props[propName].src;
      image.onload = function(){ resolve(image) };
      image.src = src;
    })
  }

  render() {
    return (
      <div style={{ width: '100%', paddingBottom: this.props.initialRatio*100+'%', position: 'relative' }}>
        <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, textAlign: 'center' }}>
          <canvas ref={(canvas) => { this.canvas = canvas; }}
                  width={this.props.width}
                  height={this.props.height}
                  className="chess"
                  style={{ maxWidth: '100%', maxHeight: '100%' }}>
          </canvas>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./app/javascript/components/image_generator/canvas.jsx